<div class="container">
  <div *ngIf="messages.length === 0" class="alert alert-info">
    Keine Nachrichten gefunden.
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>

  <div class="row">
    <div class="col-md-12" *ngFor="let message of messages">
      <div class="card mb-3">
        <div class="card-body">
          <h5 class="card-title">{{ message.subject }}</h5>
          <p class="card-text">
            <strong>Von:</strong> {{ message.name }} ({{ message.email }})
          </p>
          <p class="card-text">{{ message.message }}</p>   
          <p class="card-text">    
            <small class="text-muted">Gesendet: {{ formatFirestoreTimestamp(message.timestamp) }}</small>
          </p>

          <!-- Reply Button -->
          <a class="btn btn-sm btn-primary mt-2" [href]="'mailto:' + message.email + '?subject=Antwort: ' + message.subject">
            Antworten
          </a>
        </div>
      </div>
    </div>
  </div>
</div>